import React from 'react'
import {render} from 'react-dom'
import './index.css'
import './assets/css/style.css'
import App from './App'
import faIcons from './fontAwesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import * as serviceWorker from './serviceWorker'
import {BrowserRouter} from 'react-router-dom'
import i18n from './i18n'

library.add(faIcons)

let basename = "/signup"

if (process.env.REACT_APP_ISMYACCOUNT === 'yes') {
    basename = "/signup"
}

i18n.on('initialized', function(options) {
    render(
        <BrowserRouter basename={basename}>
            <App />
        </BrowserRouter>,
        document.getElementById('root')
    )
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
